var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadStop = function SvgFadStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.227 65.473c0-9.183 7.096-16.997 16.762-17.51 9.666-.513 116.887-.487 125.094-.487 8.207 0 17.917 9.212 17.917 17.71 0 8.499.98 117.936.49 126.609-.49 8.673-9.635 15.995-17.011 15.995-7.377 0-117.127-.327-126.341-.327-9.214 0-17.472-7.793-17.192-16.1.28-8.306.28-116.708.28-125.89z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.178 70.157c.153-3.952 3.584-5.924 7.236-5.924 3.652 0 111.493-.085 114.155 0 2.662.085 6.02 2.9 6.02 5.924 0 3.025.729 113.507.609 116.89-.12 3.383-3.246 5.17-5.932 5.456-2.687.288-110.731.198-114.852 0-4.12-.197-7.236-2.632-7.236-6.157 0-3.524-.153-112.236 0-116.189z",
    fill: "#FFF"
  }))));
};
export { SvgFadStop as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-stop.b3cde187.svg";